import { BillHistoryType } from "src/service/types/pay.type";

export const mockBillHistory: BillHistoryType[] = [
  {
    serviceBillHisUid: "bill_001",
    billType: "PAY",
    licenseCount: 10,
    externalLicenseCount: 0,
    userPerStorage: 1,
    userPerPrice: 0,
    payDate: "20240101",
    nextPayDate: "20240131",
    subscriptionStartDate: "20240101",
    subscriptionEndDate: "20240131",
    orderId: "order_001",
    subscriptionId: "subscription_001",
    billCode: "bill_001",
    payTerm: "month",
    priceUid: "price_001",
    priceType: "plus",
    priceName: "plus",
    totalPrice: 263,
    discountPrice: 0,
    confirmUrl: null,
    currency: "WON",
    payCompany: "INICIS",
    referralId: null,
    cardAuthCode: "",
    product: "WRAPSODY",
    inicisTid: "INICIS_TID_001",
    creditPrice: 0,
    usedCouponCode: "COUPON_001",
    visiblePrice: "100,000",
  },
  {
    serviceBillHisUid: "bill_001",
    billType: "PAY",
    licenseCount: 10,
    externalLicenseCount: 0,
    userPerStorage: 1,
    userPerPrice: 0,
    payDate: "20240101",
    nextPayDate: "20240131",
    subscriptionStartDate: "20240101",
    subscriptionEndDate: "20240131",
    orderId: "order_001",
    subscriptionId: "subscription_001",
    billCode: "bill_001",
    payTerm: "month",
    priceUid: "price_001",
    priceType: "plus",
    priceName: "plus",
    totalPrice: 263,
    discountPrice: 0,
    confirmUrl: null,
    currency: "WON",
    payCompany: "INICIS",
    referralId: null,
    cardAuthCode: "",
    product: "WRAPSODY",
    inicisTid: "INICIS_TID_001",
    creditPrice: 0,
    usedCouponCode: "COUPON_001",
    visiblePrice: "100,000",
  },
  {
    serviceBillHisUid: "bill_001",
    billType: "PAY",
    licenseCount: 10,
    externalLicenseCount: 0,
    userPerStorage: 1,
    userPerPrice: 0,
    payDate: "20240101",
    nextPayDate: "20240131",
    subscriptionStartDate: "20240101",
    subscriptionEndDate: "20240131",
    orderId: "order_001",
    subscriptionId: "subscription_001",
    billCode: "bill_001",
    payTerm: "month",
    priceUid: "price_001",
    priceType: "plus",
    priceName: "plus",
    totalPrice: 263,
    discountPrice: 0,
    confirmUrl: null,
    currency: "WON",
    payCompany: "INICIS",
    referralId: null,
    cardAuthCode: "",
    product: "WRAPSODY",
    inicisTid: "INICIS_TID_001",
    creditPrice: 0,
    usedCouponCode: "COUPON_001",
    visiblePrice: "100,000",
  },
];
